namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustInRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        StkAdjCode?: string;
        StkAdjcodeName?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockFrom?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        AdjustInDtList?: IcStockAdjustInDtRow[];
        CancelFg?: CancelFgstatus;
        AdjFg?: number;
    }

    export namespace IcStockAdjustInRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockAdjustIn';
        export const lookupKey = 'Inventory.IcStockAdjustIn';

        export function getLookup(): Q.Lookup<IcStockAdjustInRow> {
            return Q.getLookup<IcStockAdjustInRow>('Inventory.IcStockAdjustIn');
        }
        export const deletePermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const insertPermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const readPermission = '2Inventory:รายการ:ปรับปรุง:View';
        export const updatePermission = '2Inventory:รายการ:ปรับปรุง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            StkAdjCode = "StkAdjCode",
            StkAdjcodeName = "StkAdjcodeName",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockFrom = "StockFrom",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            AdjustInDtList = "AdjustInDtList",
            CancelFg = "CancelFg",
            AdjFg = "AdjFg"
        }
    }
}
